import { AuthHeader } from '@auth/components/display/authHeader';
import { SplitLayout } from '@components/layout';
import { Alert, Box, Typography } from '@mui/material';
import { setTitle } from '@store/appSlice';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

type Props = {
    fullPage?: boolean;
};

const Content = () => (
    <Alert severity="error">
        <Typography fontFamily="Roboto" fontWeight={500} fontSize={16} letterSpacing={0.15}>
            <FormattedMessage id="error.notFound" defaultMessage="Resource not found!" />
        </Typography>
    </Alert>
);

const NotFound = ({ fullPage }: Props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setTitle(''));
    }, [dispatch]);

    return fullPage ? (
        <SplitLayout>
            <AuthHeader />
            <Box pt={4} px={4}>
                <Content />
            </Box>
        </SplitLayout>
    ) : (
        <Box pt={4} px={4}>
            <Content />
        </Box>
    );
};

export { NotFound };
